<script lang="ts">
  import WorkOrderAppointmentTag from "../../../../../../../../../../../../../../_shared/_modules/work-order-appointment-tag"
  import type { WrongRecipientAppointmentPresentation } from "../../../../contract"

  let {
    presentation = null,
    disabled = false,
  }: {
    presentation?: WrongRecipientAppointmentPresentation | null
    disabled?: boolean
  } = $props()
</script>

<WorkOrderAppointmentTag
  status={presentation?.status ?? null}
  subLabel={presentation?.subLabel ?? null}
  tooltipContent={presentation?.tooltipContent ?? null}
  fallbackLabel={presentation?.fallbackLabel ?? "—"}
  {disabled}
/>
